import { render, staticRenderFns } from "./CustomFieldFile.vue?vue&type=template&id=1c74cc84&scoped=true"
import script from "./CustomFieldFile.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomFieldFile.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CustomFieldFile.vue?vue&type=style&index=0&id=1c74cc84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c74cc84",
  null
  
)

export default component.exports